import { IVA } from "utilsstile.js/instanciaaxios"
import {
    CarritoTicket, Metodos, ComisionesPago,
    DatosUsuarioLocalStorang,
    Valorcarrito, listaasiento,
    sillaspalco, seleccionmapa, Eventoid, concierto
} from "./constantes"
import { clienteInfo, getDatosUsuariosLocalStorag } from "./DatosUsuarioLocalStorag"
import { logWithCallback } from "utilsstile.js/style"
import { sub } from "date-fns"
import { montoDescontado } from "./descuentoTexto"
let PViten = []
let PVsilla = []

// codigoEvento del evento completo: aplica a todas las localidades
export const EVENTOS_SIN_EXTRAS = ['']
// { codigoEvento, localidad } exactos de eventos_localidad: aplica solo a esa localidad de ese evento.
// No se usa el id numérico de eventos_localidad porque el carrito no lo trae (idcolor/id_localidad
// viene de un JOIN por nombre contra la tabla de mapas y para localidades sin mapa queda undefined).
export const LOCALIDADES_SIN_EXTRAS = [
    { codigoEvento: 'RHX614', localidad: 'EL MEJOR' },
]
export const MODO_PROMOCION_KEY = "modoPromocion"
export function TiendaIten(producto) {
    VerTienda()
    const existe = PViten.some(iten => iten.localidad === producto.localidad)
    if (existe) {
        const deltaCantidad = Number(producto.cantidad) || 0
        // BUG FIX: antes, si el item ya en el carrito tenia cantidad 0 (justo
        // el caso de seleccionar un asiento y deseleccionarlo), esto hacia
        // `return item` -- variable inexistente, ReferenceError que rompia
        // el carrito. Y si no habia cambio de cantidad (deltaCantidad === 0)
        // el .map() no retornaba nada para ese item -> quedaba `undefined`
        // metido en el carrito, y GetValores() explotaba mas adelante al
        // leer .localidaEspacio/.cantidad de un undefined.
        const Product = PViten.map(iten => {
            if (iten.localidad === producto.localidad && deltaCantidad !== 0) {
                iten.cantidad = iten.cantidad + deltaCantidad
            }
            return iten
        })
        PViten = [...Product];
        sessionStorage.setItem(CarritoTicket, JSON.stringify(PViten))
        let array = JSON.parse(sessionStorage.getItem(CarritoTicket))
        return array
    } else {
        sessionStorage.setItem(CarritoTicket, JSON.stringify([...PViten, producto]))
        let array = JSON.parse(sessionStorage.getItem(CarritoTicket))
        return array
    }
}
export function TiendaSillas(producto) {
    VerTienda()
    sessionStorage.setItem(CarritoTicket, JSON.stringify([...PViten, producto]))
    let array = JSON.parse(sessionStorage.getItem(CarritoTicket))
    return array
}

function VerTienda() {
    try {
        let iten = JSON.parse(sessionStorage.getItem(CarritoTicket));
        if (iten !== null) {
            PViten = iten.filter(iten => iten.cantidad > 0);
        }
    } catch (error) {

    }
}

export function getVerTienda() {
    try {
        let iten = JSON.parse(sessionStorage.getItem(CarritoTicket));
        if (iten !== null) {
            PViten = [];
            return PViten = iten.filter(iten => iten.cantidad > 0);
        } else {
            PViten = [];
            sessionStorage.removeItem(CarritoTicket)
            return PViten
        }
    } catch (error) {
    }
}
export function verAsientos() {
    try {
        let item = JSON.parse(sessionStorage.getItem("asientosList"))
        if (item != null) {
            return item.map(e => {
                return {
                    id_silla: e.ids,
                    id: e.localidaEspacio.idcolor,
                    cedula: e.cedula,
                    estado: "",
                    ...e
                }
            })
        } else {
            return []
        }
    } catch (error) {
        return []
    }
}
export function EliminarByStora(localidad) {
    // BUG FIX: si el carrito ya estaba vacio (CarritoTicket null en
    // sessionStorage) esto tronaba con "Cannot read properties of null
    // (reading 'filter')".
    let iten = JSON.parse(sessionStorage.getItem(CarritoTicket)) || [];
    let Cost = iten.filter(tienda => tienda.localidad !== localidad)
    sessionStorage.setItem(CarritoTicket, JSON.stringify(Cost));
    return getVerTienda()
}
export function EliminarSillas(silla) {
    let nuevo = PVsilla.filter((e) => { return e.seleccionmapa != silla.localidad + "-" + silla.silla })
    const isBelowThreshold = (currentValue) => currentValue.localidad == silla.localidad;
    if (nuevo.filter(isBelowThreshold).length == 0) {
        let iten = JSON.parse(sessionStorage.getItem(CarritoTicket));
        let Cost = []
        Cost = iten.filter(tienda => tienda.localidad != silla.localidad)
        sessionStorage.setItem(CarritoTicket, JSON.stringify(Cost));
        sessionStorage.setItem(listaasiento, JSON.stringify(nuevo));
        Filterduplicados()
        getVerTienda()
    } else
        sessionStorage.setItem(listaasiento, JSON.stringify(nuevo));
    Filterduplicados()
    getVerTienda()
}

export function EliminarsilladeMesa(silla) {
    VerSillas()
    let ListadeSillas = PVsilla.filter((iten) => iten.seleccionmapa != silla.localidad)
    sessionStorage.setItem(listaasiento, JSON.stringify(ListadeSillas));
    Filterduplicados()
    //getVerTienda()
}
export function Verificalocalidad(valor, id) {
    let user = getDatosUsuariosLocalStorag()
    VerTienda()
    if (PViten.some(item => item.id == valor.id) && id.find(e => e.cedula == user.cedula) != undefined) {
        let index = PViten.findIndex(k => k.id == valor.id)
        PViten[index] = { ...valor, cantidad: id.find(e => e.cedula == user.cedula).cantidad, protocol: id.find(e => e.cedula == user.cedula).protocol }
        sessionStorage.setItem(CarritoTicket, JSON.stringify(PViten))
        let array = JSON.parse(sessionStorage.getItem(CarritoTicket))

        return array
    }
    else if (id.find(e => e.cedula == user.cedula) != undefined) {
        PViten.push({ ...valor, cantidad: id.find(e => e.cedula == user.cedula).cantidad, protocol: id.find(e => e.cedula == user.cedula).protocol })
        sessionStorage.setItem(CarritoTicket, JSON.stringify(PViten))
        let array = JSON.parse(sessionStorage.getItem(CarritoTicket))

        return array
    }
}
export function GetCantidades() {
    let iten = JSON.parse(sessionStorage.getItem(CarritoTicket))
    if (iten !== null) {
        let cantidad_1 = 0
        let cantidad_2 = 0
        iten.map(tienda => {
            if (tienda.localidad == "PEGA LA VUELTA - PREFERENCIAL") {
                cantidad_2 += tienda.cantidad
            }
            if (tienda.localidad == "A ESA - GENERAL") {
                cantidad_1 += tienda.cantidad
            }
        })
        return {
            cantidad_1,
            cantidad_2
        }
    } else {
        return {
            cantidad_1: 0,
            cantidad_2: 0
        }
    }
}
export function AgregarAsiento(sillas) {
    VerSillas()
    PVsilla.push(sillas)
    sessionStorage.setItem(listaasiento, JSON.stringify(PVsilla))
    Filterduplicados()

}

let valorDuplicadas = [];
function Filterduplicados() {
    VerSillas()
    VerTienda()
    let ListadeSillas = PVsilla.filter((iten) => iten.estado == "reservado" || iten.estado == "seleccionado")
    ListadeSillas.length > 0 ? ListadeSillas.forEach((p, i) => {
        if (valorDuplicadas.findIndex(pd => pd.localidad === p.localidad) === -1) {
            valorDuplicadas.push({ localidad: p.localidad, fila: '', tipo: p.localidaEspacio["typo"] ? p.localidaEspacio["typo"] : "mesa", id: p.localidaEspacio["idcolor"] | p.localidaEspacio["id_localidad"], localidaEspacio: p.localidaEspacio, id: p.localidaEspacio["idcolor"] | p.localidaEspacio["id_localidad"], nombreConcierto: p.nombreConcierto, valor: p.valor, cantidad: 1, discapacidad: p.localidaEspacio.precio_discapacidad, ...p });
        }
        else {
            valorDuplicadas[valorDuplicadas.findIndex(pd => pd.localidad === p.localidad)].fila = parseInt(valorDuplicadas[valorDuplicadas.findIndex(pd => pd.localidad === p.localidad)].fila) + 1;
            valorDuplicadas[valorDuplicadas.findIndex(pd => pd.localidad === p.localidad)].valor = parseFloat(valorDuplicadas[valorDuplicadas.findIndex(pd => pd.localidad === p.localidad)].valor);
        }
    }) : ''
    // BUG FIX: `sessionStorage.sillaspalco = ...` asigna una propiedad
    // cualquiera al objeto Storage, NO escribe la clave real -- sessionStorage
    // .getItem(sillaspalco) en otro lado del codigo nunca leia este valor.
    // setItem() es la forma correcta de persistirlo.
    sessionStorage.setItem(sillaspalco, JSON.stringify(valorDuplicadas))
    valorDuplicadas.length > 0 ? valorDuplicadas.forEach((e, i) => {
        if (PViten.findIndex(item => item.localidad === e.localidad) === -1) {
            PViten.push({ localidad: e.localidad, fila: e.fila, localidaEspacio: e.localidaEspacio, nombreConcierto: e.nombreConcierto, valor: e.valor, cantidad: 1, discapacidad: e.localidaEspacio.precio_discapacidad })
        } else {
            let cantidad = ListadeSillas.filter(f => f.localidad == e.localidad).length
            PViten[PViten.findIndex(item => item.localidad === e.localidad)].cantidad = cantidad
            PViten[PViten.findIndex(item => item.localidad === e.localidad)].valor = e.valor
        }
    }) : ''
    PViten.length > 0 ? sessionStorage.setItem(CarritoTicket, JSON.stringify(PViten)) : ''
}
export function EliminarSillaLocal(silla) {
    VerSillas()
    let nuevo = PVsilla.filter(e => e.localidad != silla)
    sessionStorage.setItem(listaasiento, JSON.stringify(nuevo));
}

function VerSillas() {
    try {
        let iten = JSON.parse(sessionStorage.getItem(listaasiento));
        if (iten != null) {
            PVsilla = iten
        } else {
            // BUG FIX: esto reseteaba PViten (carrito) en vez de PVsilla
            // (asientos) -- PVsilla se quedaba con datos de la seleccion
            // anterior aunque sessionStorage ya estuviera vacio (ej. despues
            // de Limpiarseleccion()), arrastrando asientos viejos a la
            // siguiente seleccion/evento.
            PVsilla = []
        }
    } catch (error) {
    }

}
function ListaEliminaLocalida() {
    let user = getDatosUsuariosLocalStorag()
    let iten = JSON.parse(sessionStorage.getItem(listaasiento));
    if (iten != undefined && iten != null) {
        return iten.map(e => {
            return {
                silla: e.silla, cedula: user.cedula,
                id: e.localidaEspacio["idcolor"],
                estado: "disponible"
            }
        })
    }
    else {
        return []
    }
}
export function ListaElimnaLCompleta() {
    return ListaEliminaLocalida()
}
export function listaEliminasillas(parms) {
    let nuevo = ListaEliminaLocalida().filter(e => e.id == parms)
    sessionStorage.setItem("Listaele", JSON.stringify(nuevo))
    return ListaEliminaLocalida().filter(e => e.id == parms)
}
export function VerSillaslist() {
    try {
        let iten = JSON.parse(sessionStorage.getItem(listaasiento));
        if (iten != null) {
            iten.filter((e) => e.estado === "seleccionado").map((e) => {
                e.estado = 'ocupado'
                return e
            })
            return [...iten]
        } else {
            return []
        }
    } catch (error) {
    }

}
export function TotalSelecion() {
    let total = 0
    try {
        let iten = JSON.parse(sessionStorage.getItem(CarritoTicket))
        if (iten != null) {
            iten.map((e) => {
                total = total + e.cantidad
            })
            return total
        } else {
            return 0
        }
    } catch (err) {
    }
}
export function GetEstadousu() {
    let user = JSON.parse(sessionStorage.getItem(DatosUsuarioLocalStorang))
    if (user == null) return { discapacidad: "No" }
    else if (user) return { discapacidad: user.discapacidad }
}


// Mapea el "metodo" del carrito al nombre de fila en configuracion_pagos,
// igual que CONFIG_METODO_MAP del lado del backend. Transferencia/Deposito/
// Efectivo-Local se agregan aca para que su % configurado en Ajustes pise el
// valor fijo de mas abajo (que queda solo como respaldo si todavia no cargo
// la config o el metodo no tiene fila propia).
// "Canje" queda afuera a proposito: es para boletos de cortesia/canje sin
// costo real, y no debe quedar bloqueable desde Ajustes.
const CONFIG_METODO_MAP = {
    Tarjeta: "Abitmedia", Duna: "Duna", PagoPlux: "PagoPlux", Payphone: "Payphone", Stripe: "Stripe", PayPal: "PayPal",
    Transferencia: "Transferencia", Deposito: "Deposito", "Efectivo-Local": "Efectivo-Local",
    Efectivo: "Efectivo", "Tarjeta-Local": "Tarjeta-Local", "Efectivo-Fisico": "Efectivo-Fisico",
    "Efectivo-QR": "Efectivo-QR", "Tarjeta-QR": "Tarjeta-QR",
}

// El porcentaje de comision bancaria de cada pasarela se configura desde
// Ajustes > Metodos de Pago; ModalFormasPago.js/ModalPago.js guardan la
// respuesta de /api/v1/metodos_pago_activos (que incluye comision_porcentaje)
// en sessionStorage al cargar, para que GetValores() lo pueda leer de forma
// sincrona sin volverse una funcion async.
function obtenerPorcentajeComisionConfigurado(metodo) {
    const filaConfig = CONFIG_METODO_MAP[metodo]
    if (!filaConfig) return null
    try {
        const comisiones = JSON.parse(sessionStorage.getItem(ComisionesPago) || "[]")
        const encontrado = Array.isArray(comisiones) ? comisiones.find((c) => c.metodo === filaConfig) : null
        return encontrado ? (parseFloat(encontrado.comision_porcentaje) || 0) : null
    } catch (_error) {
        return null
    }
}

// Si el evento restringio en que metodos se cobra la comision de la
// ticketera (comision_boleto por evento -- ver ComisionBoletoPanel.js y
// migracion 2026-09-14-comision-boleto-metodos-evento.sql), el backend ya
// resuelve aplica_comision_boleto por metodo dentro de la MISMA respuesta
// de /api/v1/metodos_pago_activos que se cachea en ComisionesPago (igual
// que el % bancario). Default TRUE (se cobra) si no hay dato en cache --
// asi una carga fallida nunca deja de cobrar la comision por error.
export function aplicaComisionBoletoParaMetodo(metodo) {
    const filaConfig = CONFIG_METODO_MAP[metodo]
    if (!filaConfig) return true
    try {
        const comisiones = JSON.parse(sessionStorage.getItem(ComisionesPago) || "[]")
        const encontrado = Array.isArray(comisiones) ? comisiones.find((c) => c.metodo === filaConfig) : null
        return encontrado ? (encontrado.aplica_comision_boleto !== false) : true
    } catch (_error) {
        return true
    }
}

// % de descuento por link publico (?desc=CODIGO en la tienda), ya validado
// por Flasdeticket/index.js contra el backend y guardado con su porcentaje
// en sessionStorage. Antes esto solo se mostraba como nota aparte en
// ModalPago.js -- el "Total" de ModalCarritov/ModalFormasPago seguia sin
// descuento hasta ahi, que es el precio que de verdad ve el cliente al
// comprar. Ahora GetValores() expone `total_con_descuento` para que esas
// pantallas puedan pintar el precio real. Se exige que coincida el
// codigoEvento del link con el evento actual (`infoevento` en sessionStorage)
// para no arrastrar el descuento si el cliente navega a otro evento sin
// completar la compra.
// El descuento que elige un vendedor a mano se guarda en
// descuentoVentaSel:{id, porcentaje, aplica_sobre} (ModalPago.js lo completa
// con el detalle de ListarDescuentosVendedor al elegirlo) -- se resuelve mas
// abajo en obtenerDescuentoActivo(), junto con este de link publico.
// Descuento por MONTO FIJO guardado del link / codigo ({ montoUnitario, montoPor }) o null. Solo vale para el evento actual.
function obtenerMontoDescuentoLink() {
    try {
        const link = JSON.parse(sessionStorage.getItem("descuentoLinkPublico") || "null")
        if (!link || link.tipo_descuento !== "monto") return null
        const evento = JSON.parse(sessionStorage.getItem("infoevento") || "null")
        if (link.codigoEvento && evento?.codigoEvento && String(link.codigoEvento) !== String(evento.codigoEvento)) return null
        const montoUnitario = Number(link.monto_descuento)
        if (!Number.isFinite(montoUnitario) || montoUnitario <= 0) return null
        return { montoUnitario, montoPor: link.monto_por === "compra" ? "compra" : "entrada" }
    } catch (_error) {
        return null
    }
}

function obtenerPorcentajeDescuentoLink() {
    try {
        const link = JSON.parse(sessionStorage.getItem("descuentoLinkPublico") || "null")
        if (!link) return 0
        const evento = JSON.parse(sessionStorage.getItem("infoevento") || "null")
        if (link.codigoEvento && evento?.codigoEvento && String(link.codigoEvento) !== String(evento.codigoEvento)) {
            return 0
        }
        const pct = Number(link.porcentaje)
        return Number.isFinite(pct) && pct > 0 ? pct : 0
    } catch (_error) {
        return 0
    }
}

// 'base' = el % se resta del PRECIO BASE del boleto, y recien despues se
// calculan IVA/comision bancaria sobre ese precio ya reducido (la comision
// de boleteria, al ser un monto fijo por boleto, no cambia con esto).
// 'final' (default, comportamiento de siempre) = el % se resta del total ya
// armado (precio + iva + comisiones), sin tocar el desglose. Configurable
// por tipo de descuento en DescuentosPanel.js -- ver migracion
// 2026-09-descuentos-aplica-sobre.sql.
function obtenerAplicaSobreDescuentoLink() {
    try {
        const link = JSON.parse(sessionStorage.getItem("descuentoLinkPublico") || "null")
        return link?.aplica_sobre === "base" ? "base" : "final"
    } catch (_error) {
        return "final"
    }
}

// Descuento REALMENTE activo para esta venta, sin importar el origen -- el
// que un vendedor elige a mano en ModalPago (descuentoVentaSel:{id,
// porcentaje, aplica_sobre}) tiene prioridad sobre uno por link publico,
// mismo orden que ya usaba el preview de ModalPago.js. Antes GetValores()
// solo miraba el de link (obtenerPorcentajeDescuentoLink/
// obtenerAplicaSobreDescuentoLink) -- un descuento elegido a mano con
// aplica_sobre='base' nunca reducia el precio base aca, y como el backend
// confia en que el frontend YA lo hizo en ese modo (ver
// RegistraCompra.controller.js), el cliente terminaba pagando el total
// bruto completo, sin ningun descuento real.
function obtenerDescuentoActivo() {
    try {
        const ventaSel = JSON.parse(sessionStorage.getItem("descuentoVentaSel") || "null")
        const eventoActual = JSON.parse(sessionStorage.getItem("infoevento") || "null")?.codigoEvento
        const deOtroEvento = ventaSel?.codigoEvento && eventoActual && String(ventaSel.codigoEvento) !== String(eventoActual)
        if (ventaSel && ventaSel.id && Number(ventaSel.porcentaje) > 0 && !deOtroEvento) {
            return {
                porcentaje: Number(ventaSel.porcentaje),
                aplicaSobre: ventaSel.aplica_sobre === "base" ? "base" : "final",
            }
        }
    } catch (_error) { /* noop */ }
    // Monto fijo en dolares (solo por link / codigo): siempre se resta del total final
    const montoLink = obtenerMontoDescuentoLink()
    if (montoLink) {
        return { porcentaje: 0, aplicaSobre: "final", tipo: "monto", ...montoLink }
    }
    const pctLink = obtenerPorcentajeDescuentoLink()
    if (pctLink > 0) {
        return { porcentaje: pctLink, aplicaSobre: obtenerAplicaSobreDescuentoLink() }
    }
    return { porcentaje: 0, aplicaSobre: "final" }
}

export function GetValores() {

    let tag = JSON.parse(sessionStorage.getItem(CarritoTicket));
    let forma = sessionStorage.getItem(Metodos)
    let metodo = forma
    let porcentajeBancario = 0
    if (metodo == "Tarjeta" || metodo == "Tarjeta-Local") porcentajeBancario = 0.15
    if (metodo == "Transferencia") porcentajeBancario = 0.08
    if (metodo == "Duna") porcentajeBancario = 0.11
    if (metodo == "PagoPlux") porcentajeBancario = 0.11
    if (metodo == "Payphone") porcentajeBancario = 0.11
    if (metodo == "Efectivo") porcentajeBancario = 0.08
    // El % configurado ya viene por evento: ListarMetodosPagoActivos(codigoEvento)
    // (ver ModalFormasPago.js/ModalPago.js/Ventas/index.js) le pasa el evento actual
    // al backend, que aplica el override de configuracion_pagos_evento si existe
    // para ese metodo+evento (si no, usa el % global). Antes esto se resolvia con
    // una excepcion fija en codigo (solo Efectivo-Local en el evento 4K93VK);
    // ahora es un dato editable desde Ajustes para cualquier metodo/evento.
    const porcentajeConfigurado = obtenerPorcentajeComisionConfigurado(metodo)
    if (porcentajeConfigurado != null) porcentajeBancario = porcentajeConfigurado
    let codicontry = sessionStorage.getItem("codicontry") ? sessionStorage.getItem("codicontry") : false
    let evento = JSON.parse(sessionStorage.getItem("infoevento"))

    // BUG FIX: la linea de abajo (eventoiva) y el resto de la funcion leen
    // evento.iva/evento.codigoEvento sin chequear null -- si por lo que sea
    // "infoevento" no esta en sessionStorage (pestaña vieja, navegacion
    // directa a checkout, etc.) esto tronaba con TypeError y tumbaba toda la
    // pantalla de compra (no se podia ni ver el total). Sin datos del evento
    // no hay forma confiable de calcular IVA/exclusiones, asi que se trata
    // como carrito vacio en vez de crashear.
    if (evento === null) {
        return { total: 0, comision: 0, subtotal: 0 }
    }

    let eventoiva = evento != null && evento.hasOwnProperty(iva) ? "1.00" : evento.iva

    let user = JSON.parse(sessionStorage.getItem(DatosUsuarioLocalStorang)) ? JSON.parse(sessionStorage.getItem(DatosUsuarioLocalStorang)) : { discapacidad: "No" }
    var valor = 0;
    var subtotal = 0;
    var subtotalGravable = 0;
    var comision = 0;
    var sumcomision = 0;
    var descrption = ""
    let total = 0
    var iva = 0
    if (tag !== null) {
        const eventoSinExtras = EVENTOS_SIN_EXTRAS.includes(evento.codigoEvento)
        let cantidadTotal = tag.reduce((total, concierto) => {
            return total + concierto.cantidad;
        }, 0);
        // Se resuelven ANTES del primer map porque, si el descuento aplica
        // sobre el precio BASE, hay que reducir tienda2.valor ACA -- todo lo
        // que se calcula despues (subtotal, iva, comision bancaria, total)
        // sale solo de ese valor ya reducido, sin tocar nada mas. Se resuelve
        // el descuento ACTIVO (vendedor o link, ver obtenerDescuentoActivo)
        // para que el modo 'base' funcione igual sin importar el origen.
        const descuentoActivo = obtenerDescuentoActivo()
        const porcentajeDescuentoLink = descuentoActivo.porcentaje
        const aplicaSobreDescuentoLink = descuentoActivo.aplicaSobre
        const descuentaPrecioBase = porcentajeDescuentoLink > 0 && aplicaSobreDescuentoLink === "base"
        const descuentoEsMonto = descuentoActivo.tipo === "monto"
        // Entradas que se cobran (con factor de boletos, un paquete cuenta como 1): lo que multiplica un monto "por entrada"
        let entradasCobradas = 0
        // Valor de cada linea ANTES de aplicar el descuento al precio base: sirve para mostrar
        // "precio normal" vs "precio con descuento" (no cambia ningun calculo).
        const valoresSinDescuento = []
        tag.map(tienda2 => {
            const factorBoletos = Number(tienda2?.localidaEspacio?.factor_boletos || tienda2?.factor_boletos || 1)
            const cantidadAsientos = parseInt(tienda2.cantidad) || 0
            const cantidadCobro = factorBoletos > 1 ? Math.ceil(cantidadAsientos / factorBoletos) : cantidadAsientos
            tienda2.cantidad_cobro = cantidadCobro
            entradasCobradas += cantidadCobro
            //tienda2.localidaEspacio.descuento>0
            if (false) {
                let descuento = "1." + tienda2.localidaEspacio.descuento
                tienda2.valor = (parseFloat(tienda2.valor) * parseInt(tienda2.cantidad)) / parseFloat(descuento)
            } else {
                let valor = parseInt(tienda2.cantidad) % 2
                if (codicontry && cantidadTotal > 3) {
                    //if ((evento.codigoEvento=="X5U5VR")&& (valor==1)) {
                    tienda2.valor = (parseFloat(tienda2.localidaEspacio["precio_descuento"]) * cantidadCobro)

                } else {
                    const precioDiscapacidad = parseFloat(tienda2?.localidaEspacio?.["precio_discapacidad"] || 0)
                    const precioNormal = parseFloat(tienda2?.localidaEspacio?.["precio_normal"] || tienda2?.valor || 0)
                    const aplicaDescuento = user.discapacidad == 'Si' && Number.isFinite(precioDiscapacidad) && precioDiscapacidad > 0
                    const valorUnitario = aplicaDescuento ? precioDiscapacidad : precioNormal
                    tienda2.valor = (valorUnitario * cantidadCobro)
                }
            }
            valoresSinDescuento.push(tienda2.valor)
            if (descuentaPrecioBase) {
                tienda2.valor = tienda2.valor * (1 - porcentajeDescuentoLink / 100)
            }
            return tienda2

        })

        // Si el evento restringio la comision de boleteria a solo algunos
        // metodos de pago (ComisionBoletoPanel.js), este metodo actual queda
        // en $0 de comision_boleto aunque la localidad si la tenga configurada.
        const cobraComisionBoleto = aplicaComisionBoletoParaMetodo(metodo)
        let subtotalSinDescuento = 0
        let subtotalGravableSinDescuento = 0
        tag.map((tienda, indiceLinea) => {
            let comisioreal = cobraComisionBoleto ? tienda.localidaEspacio["comision_boleto"] : 0
            const cantidadBoletosEmitidos = parseInt(tienda.cantidad || 0)
            let valores = tienda.valor
            subtotal += valores
            descrption = tienda.nombreConcierto
            const valorLineaSinDescuento = valoresSinDescuento[indiceLinea] ?? valores
            subtotalSinDescuento += valorLineaSinDescuento
            const localidadSinExtras = LOCALIDADES_SIN_EXTRAS.some(l => l.codigoEvento === evento.codigoEvento && l.localidad === tienda.localidad)
            if (!eventoSinExtras && !localidadSinExtras) {
                subtotalGravableSinDescuento += valorLineaSinDescuento
                subtotalGravable += valores
                sumcomision += cantidadBoletosEmitidos * parseFloat(comisioreal)
            }
        })
        comision = parseFloat(sumcomision)
        // BUG FIX: evento.iva llega null cuando el evento no tiene IVA
        // configurado en BD -- .replace() sobre null tronaba con TypeError
        // ("Cannot read properties of null") y, al no haber ErrorBoundary,
        // tumbaba toda la pantalla del carrito a blanco apenas se armaba el
        // evento (ej. FESTIVAL URBANO). "1.00" = +0% IVA, mismo default que
        // ya se usaba mas arriba (eventoiva) para este caso.
        const ivaConfigurado = evento.iva || "1.00"
        let ivados = ivaConfigurado.replace("1.", "0.")
        valor = parseInt((ivados).replace("0.", " ")) == 0 ? (subtotalGravable) : (subtotalGravable);
        // let ivados = (eventoiva).replace("1.","0.")
        iva = parseInt(ivados) == 0 ? ((subtotalGravable) * parseFloat(ivados)) : (subtotalGravable) * parseFloat(ivaConfigurado)
        const recargoEspecial = (!eventoSinExtras && ["1RX4Q1", "D0FFSD", "TU5YMD", "OGX3DU"].some(el => el == evento.codigoEvento) ? 0.25 : 0)
        const baseComisionBancaria = parseFloat(valor) + parseFloat(iva)
        let comisionBancaria = subtotalGravable > 0 ? baseComisionBancaria * porcentajeBancario : 0
        const subtotalExento = subtotal - subtotalGravable
        total = parseFloat(valor) + comision + parseFloat(iva) + comisionBancaria + recargoEspecial + subtotalExento

        // OJO: si el descuento es sobre el precio FINAL (default), `total`
        // sigue siendo el BRUTO (sin descuento) a proposito -- es lo que se
        // manda al backend en `valores.total` (Querycomnet.js PagoRapido), y
        // el backend aplica el % de descuento sobre ESE bruto
        // (RegistraCompra.controller.js: `bruto = parseFloat(total)`). Si aca
        // ya viniera descontado, el backend lo descontaria una segunda vez.
        // Si en cambio es sobre el precio BASE, `total` YA sale neto (el
        // descuento se aplico mas arriba, sobre tienda2.valor, antes de
        // calcular iva/comision) -- no hay que restarle el % de nuevo aca, ni
        // el backend lo vuelve a tocar (ver descuentoResuelto.aplicaSobre en
        // RegistraCompra.controller.js).
        // `total_con_descuento` es solo para PINTAR el precio real en
        // pantalla (ModalFormasPago.js) antes de llegar a ModalPago.
        // Monto fijo: se resta del total BRUTO (el mismo que recibe el backend) sin bajar de $0, igual que calcularDescuentoMonto
        const montoFijoDescontado = descuentoEsMonto
            ? montoDescontado({ bruto: parseFloat(total.toFixed(2)), montoUnitario: descuentoActivo.montoUnitario, montoPor: descuentoActivo.montoPor, entradas: entradasCobradas })
            : 0
        const totalConDescuentoLink = descuentoEsMonto
            ? Math.round((parseFloat(total.toFixed(2)) - montoFijoDescontado) * 100) / 100
            : (porcentajeDescuentoLink > 0 && !descuentaPrecioBase)
                ? Math.round(total * (1 - porcentajeDescuentoLink / 100) * 100) / 100
                : parseFloat(total.toFixed(2))

        // Lo que se pagaria SIN el descuento (mismas formulas de arriba, con el precio original):
        // con el precio base descontado el desglose ya viene reducido, y el cliente tiene que poder
        // ver cuanto era antes. Solo se usa para mostrar en pantalla.
        const gravableSinDescuento = subtotalGravableSinDescuento
        const ivaSinDescuento = parseInt(ivados) == 0 ? (gravableSinDescuento * parseFloat(ivados)) : gravableSinDescuento * parseFloat(ivaConfigurado)
        const comisionBancariaSinDescuento = gravableSinDescuento > 0 ? (gravableSinDescuento + ivaSinDescuento) * porcentajeBancario : 0
        const totalSinDescuento = gravableSinDescuento + comision + ivaSinDescuento + comisionBancariaSinDescuento + recargoEspecial + (subtotalSinDescuento - gravableSinDescuento)
        const hayDescuento = porcentajeDescuentoLink > 0 || (descuentoEsMonto && montoFijoDescontado > 0)
        const totalSinDescuentoRedondeado = parseFloat(totalSinDescuento.toFixed(2))

        let precios = {
            sumcomision: parseFloat(sumcomision).toFixed(2),
            comision_bancaria: comisionBancaria.toFixed(2),
            subtotal: parseFloat(subtotal).toFixed(2),
            description: descrption,
            comision: parseFloat(sumcomision).toFixed(2),
            envio: getDatosUsuariosLocalStorag() ? getDatosUsuariosLocalStorag().envio : '',
            iva: (iva).toFixed(2),
            total: parseFloat(total.toFixed(2)),
            desctc: parseFloat((baseComisionBancaria + comisionBancaria).toFixed(2)),
            desc: (parseFloat(subtotal) + parseFloat(comision)) / parseFloat(ivaConfigurado),
            tallv: parseFloat(total.toFixed(2)),
            tallva: parseFloat(sumcomision.toFixed(2)),
            // Precio real a pagar si hay CUALQUIER descuento activo (vendedor
            // o link -- igual a `total` si no hay ninguno). Ver comentario
            // arriba: usar SOLO para mostrar en pantalla, nunca para armar el
            // payload que se manda al backend.
            descuento_porcentaje: porcentajeDescuentoLink,
            // 'monto' = valor fijo en dolares (por entrada o por compra); null si no hay descuento por monto
            descuento_tipo: descuentoEsMonto ? "monto" : (porcentajeDescuentoLink > 0 ? "porcentaje" : null),
            descuento_valor_unitario: descuentoEsMonto ? descuentoActivo.montoUnitario : 0,
            descuento_monto_por: descuentoEsMonto ? descuentoActivo.montoPor : null,
            descuento_entradas: descuentoEsMonto ? entradasCobradas : 0,
            total_con_descuento: totalConDescuentoLink,
            // Desglose "antes y despues" para pintar el descuento (solo pantalla):
            //  - 'base': el descuento ya esta dentro de subtotal/iva/comision_bancaria; subtotal_sin_descuento
            //    es el precio normal de los boletos y descuento_monto_base lo que se rebaja de ese precio.
            //  - 'final': subtotal/iva/comisiones son los normales y el % se resta del total.
            descuento_aplica_sobre: hayDescuento ? (descuentaPrecioBase ? "base" : "final") : null,
            subtotal_sin_descuento: parseFloat(subtotalSinDescuento.toFixed(2)),
            descuento_monto_base: descuentaPrecioBase ? parseFloat((subtotalSinDescuento - subtotal).toFixed(2)) : 0,
            total_sin_descuento: totalSinDescuentoRedondeado,
            descuento_monto: hayDescuento ? Math.max(0, parseFloat((totalSinDescuentoRedondeado - totalConDescuentoLink).toFixed(2))) : 0,
        }
        sessionStorage.setItem(Valorcarrito, JSON.stringify(precios))
        return precios
    } else {
        return {
            total: 0,
            comision: 0,
            subtotal: 0
        }
    }
}
export function LimpiarLocalStore() {
    PVsilla = []
    PViten = []
    valorDuplicadas = []
    sessionStorage.removeItem(CarritoTicket)
    // sessionStorage.removeItem(Metodos)
    sessionStorage.removeItem("codicontry")
}

// BUG FIX: el descuento por link publico (?desc=CODIGO) se guardaba bien al
// entrar a la tienda, pero LimpiarLocalStore() lo borraba de nuevo apenas el
// cliente abria un evento para empezar a comprar (Flasdeticket/index.js
// abrir() llama a LimpiarLocalStore() como reseteo general) -- el mensaje de
// "obtuviste un descuento" ya se habia mostrado, pero para cuando el cliente
// llegaba a seleccionar asientos/pagar, descuentoVentaSel/descuentoLinkPublico
// ya no existian, asi que ni el total ni la compra enviada al backend lo
// aplicaban nunca. Ahora el descuento se limpia aparte, SOLO cuando la
// compra realmente se envia (ModalPago.js, en los caminos donde ya se
// registro/genero el link de pago) -- no al simplemente abrir un evento.
export function LimpiarDescuentoVenta() {
    sessionStorage.removeItem("descuentoVentaSel")
    sessionStorage.removeItem("descuentoLinkPublico")
}

// Deja guardado el descuento de un link (?desc=CODIGO) o de un codigo escrito por el cliente. `info` es lo que
// devuelve InfoDescuentoLink (data). Es lo unico que GetValores y la compra leen, asi que link y codigo funcionan igual.
export function GuardarDescuentoLinkPublico(info, codigo) {
    sessionStorage.setItem("descuentoVentaSel", JSON.stringify({ codigo }))
    sessionStorage.setItem("descuentoLinkPublico", JSON.stringify({
        codigo,
        nombre: info.nombre,
        mensaje_motivo: info.mensaje_motivo || null,
        porcentaje: Number(info.porcentaje),
        // monto fijo en dolares ('monto') o porcentaje (por defecto)
        tipo_descuento: info.tipo_descuento === "monto" ? "monto" : "porcentaje",
        monto_descuento: info.tipo_descuento === "monto" ? Number(info.monto_descuento) : null,
        monto_por: info.monto_por === "compra" ? "compra" : "entrada",
        codigoEvento: info.codigoEvento,
        // 'base' o 'final' -- ver obtenerAplicaSobreDescuentoLink
        aplica_sobre: info.aplica_sobre === "base" ? "base" : "final",
    }))
}

// Descuento por link/codigo que hay guardado ahora (o null). Con `codigoEvento` solo devuelve el de ese evento.
export function ObtenerDescuentoLinkPublico(codigoEvento) {
    try {
        const d = JSON.parse(sessionStorage.getItem("descuentoLinkPublico") || "null")
        if (!d || !d.codigo) return null
        const norm = (v) => String(v || "").replace(/_/g, "")
        if (codigoEvento && d.codigoEvento && norm(d.codigoEvento) !== norm(codigoEvento)) return null
        return d
    } catch (_error) {
        return null
    }
}
export function Limpiarseleccion() {
    // BUG FIX: antes esto solo borraba las claves de sessionStorage, sin
    // resetear PVsilla/PViten/valorDuplicadas (variables en memoria a nivel
    // de modulo). Si el siguiente paso las usaba sin pasar por
    // LimpiarLocalStore(), quedaban con datos de la seleccion/evento
    // anterior -- ej. borrar() al "Anular Compra" solo llamaba a esta
    // funcion, nunca a LimpiarLocalStore().
    PVsilla = []
    PViten = []
    valorDuplicadas = []
    sessionStorage.removeItem(sillaspalco)
    sessionStorage.removeItem(listaasiento)
    sessionStorage.removeItem(CarritoTicket)
    sessionStorage.removeItem(listaasiento)
    sessionStorage.removeItem(seleccionmapa)
    // sessionStorage.removeItem(Eventoid)
    // sessionStorage.removeItem(concierto)
    sessionStorage.removeItem("sillascorre")
}
export function Limpiarselecciondos() {
    PVsilla = []
    PViten = []
    valorDuplicadas = []
    sessionStorage.removeItem(sillaspalco)
    sessionStorage.removeItem(listaasiento)
    sessionStorage.removeItem(CarritoTicket)
    sessionStorage.removeItem(listaasiento)
    sessionStorage.removeItem(seleccionmapa)
    sessionStorage.removeItem("sillascorre")
}
export function GetMetodo() {
    let tag = sessionStorage.getItem(Metodos);
    if (tag !== null) {
        return tag;
    } else {
        return null
    }
}